// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"68b59336","619":"68b59336"}[chunkId] + ".chunk.css";
};